import React, { useState, useMemo, useCallback, useRef, useEffect } from 'react';
import { styled, LazyImage, Overlay as Overlay$1, Gallery, Currency, SvgIcon, ButtonChevron, ModalBody, ModalHeader, BlockHeader, Modal, Button, Swiper, Card, theme } from '@teko/ui';
import { t } from './i18n.es.js';
import { Flex, Box } from 'reflexbox';
import get from 'lodash.get';
import { P as PromotionType } from './types-3497cc60.js';
import { getElementOffset } from './helpers.es.js';
import { S as Specifications } from './Specifications-f6ece0ec.js';
import { __rest } from 'tslib';
import { P as ProductPrice } from './ProductPrice-aae065f6.js';
import { S as SelectOption } from './SelectOption-cd28985e.js';

const ImageWrapper$1 = styled.button((props) => `
  border-radius: 4px;
  position: relative;
  border: 1px solid ${props.active ? props.theme.brand.primary : 'transparent'};
  width: 50px;
  margin-right: .5rem;
  padding: .2rem;
  background-color: transparent;
  overflow: hidden;
  box-sizing: border-box;
  cursor: pointer;
  `);
const Image$1 = styled.img `
  object-fit: contain;
  width: 100%;
  height: calc(100% - 10px);
`;
const Extra = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;
const SmallImage = ({ image, active, onMouseEnter, onClick, extra, }) => {
    return (React.createElement(ImageWrapper$1, { active: active, onMouseEnter: onMouseEnter, onClick: onClick },
        React.createElement(Image$1, Object.assign({}, image)),
        extra && React.createElement(Extra, null, extra)));
};

const Images$1 = styled.div `
  display: flex;
  flex-direction: row;
  height: 50px;
`;
const Wrapper$5 = styled.div `
  background-color: #fff;
`;
const ActiveImageWrapper = styled.div `
  margin-bottom: 0.5rem;
  position: relative;
`;
const FrameWrapper = styled.div(({ frame }) => `
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  display: flex;
  flex-wrap: wrap;
  background-image: url(${frame});
  background-size: cover;
  height: 100%;
  width: 100%;
  cursor: pointer;
  `);
const ProductImages = ({ images, frame, sku, galleryBgColor, }) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [activeIndexSlide, setActiveIndexSlide] = useState(0);
    const activeImage = useMemo(() => images[activeIndex], [activeIndex, images]);
    const maxFourImages = useMemo(() => images.slice(0, 6), [images]);
    const [galleryVisible, setGalleryVisible] = useState(false);
    const toggleGallery = useCallback(() => {
        setGalleryVisible(!galleryVisible);
    }, [galleryVisible]);
    return (React.createElement(Wrapper$5, { "data-track-content": true, "data-content-region-name": "imgProductDetail", "data-content-name": "viewImage", "data-content-target": "productImage", "data-content-payload": JSON.stringify({
            sku,
            screenName: 'productDetail',
            index: activeIndex,
        }) },
        React.createElement(ActiveImageWrapper, { onClick: () => activeImage && toggleGallery() },
            frame && React.createElement(FrameWrapper, { frame: frame }),
            React.createElement(LazyImage, Object.assign({}, activeImage, { onClick: () => activeImage && toggleGallery(), className: "productDetailPreview", borderRadius: 8, imageWidth: 500, contain: true }))),
        React.createElement(Images$1, null, maxFourImages.map((image, index) => (React.createElement(SmallImage, { key: index, active: index === activeIndex, image: image, onMouseEnter: () => {
                !(index === 5 && images.length > 6) && setActiveIndex(index);
                setActiveIndexSlide(index);
            }, onClick: () => {
                toggleGallery();
            }, extra: index === 5 && images.length > 6
                ? `+${images.length - 6}`
                : undefined })))),
        React.createElement(Overlay$1, { show: galleryVisible, onEscPressed: toggleGallery },
            React.createElement(Gallery, { onClose: toggleGallery, images: images.map((image) => ({
                    imageUrl: image.src,
                    caption: '',
                    subCaption: '',
                    thumbnailUrl: image.src,
                })), activeImageIndex: activeIndexSlide, bgColor: galleryBgColor }))));
};

const StyledGift = styled.div `
  display: flex;
  align-items: center;
  padding: 0.25rem 0;
`;
const GiftName = styled.span `
  margin-left: 0.25rem;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 0.75rem;
`;
const EndAt = styled.span(({ theme }) => `
    color: ${theme.colors.gray400};
    margin-left: 0.5rem;
    font-size: 0.75rem;
  `);
const Quantity$2 = styled.span `
  font-size: 0.75rem;
  color: #848788;
  margin-left: 0.5rem;
`;
const DetailGifts = ({ gifts, }) => (React.createElement("div", null, gifts.map((gift, index) => (React.createElement(StyledGift, { key: index },
    React.createElement("div", null,
        React.createElement(LazyImage, { height: 32, width: 32, border: true, borderRadius: 2, contain: true, src: get(gift, 'image.src') || '' })),
    React.createElement(Quantity$2, null,
        "x",
        gift.quantity),
    React.createElement(GiftName, null, gift.name),
    gift.endAt && React.createElement(EndAt, null, gift.endAt))))));

const Wrapper$4 = styled.div((props) => `
    width: ${props.type === 'image' ? '44px' : 'fit-content'};
    height: ${props.type === 'image' ? '44px' : 'fit-content'};
    border: 1px ${props.isActive ? props.theme.brand.primary : '#e0e0e0'} solid;
    position: relative;
    border-radius: 4px;

    margin: 0 8px 8px 0;
    ${props.type !== 'image' && 'padding: 8px 16px;'}
    color: ${props.isActive ? props.theme.brand.primary : 'black'};
    background-color: ${props.isVisible || props.isActive === true ? '#fff' : '#e0e0e0'};

    text-transform: capitalize;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;


    cursor: ${props.isVisible || props.isActive === true ? 'pointer' : 'not-allowed'};
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      border-radius: 4px;
    }
`);
const Value = styled.span ``;
const ProductVariant = ({ option, type, index, onSelectVariant, }) => {
    return (React.createElement(Wrapper$4, { isActive: option.selected, isVisible: option.visible, type: type, onClick: () => onSelectVariant(option, index) }, type === 'image' && option.image ? (React.createElement(React.Fragment, null,
        React.createElement(LazyImage, { src: option.image.src, alt: option.image.alt }))) : (React.createElement(Value, null, option.value))));
};

const Wrapper$3 = styled.div `
  display: flex;
`;
const VariantWrapper = styled.div `
  margin-left: 8px;
  display: flex;
  flex-flow: wrap;
  max-width: calc(100% - 64px);
`;
const SelectedVariant = styled.div `
  font-size: 0/75rem;
  color: #848788;
  margin-top: 8px;
  text-transform: capitalize;
`;
const ProductVariants = ({ configuration, onSelectVariant, index, className, }) => {
    return (React.createElement(Wrapper$3, { className: className },
        React.createElement(SelectedVariant, null, configuration.name),
        React.createElement(VariantWrapper, null, configuration.options.map((variant) => (React.createElement(ProductVariant, { key: variant.optionId, option: variant, onSelectVariant: onSelectVariant, type: configuration.optionType, index: index }))))));
};

const Percent = styled.span `
  margin-left: 4px;
`;
const StyledCurrency$1 = styled(Currency) `
  margin: 0 4px;
  color: #ed2101;
  font-weight: 500;
`;
const OrderValueMin = styled.span `
  margin-left: 4px;
`;
const OrderValueMax = styled(Percent) ``;
const PromotionInfo = ({ money, condition, }) => {
    if (!money)
        return null;
    return (React.createElement(React.Fragment, null,
        money.discountType === 'percent' ? (React.createElement(Percent, null,
            money.percent,
            t('% tối đa'),
            React.createElement(StyledCurrency$1, { value: money.maxDiscount || 0 }))) : (React.createElement(StyledCurrency$1, { value: money.money || 0 })),
        condition && (React.createElement(React.Fragment, null,
            condition.orderValueMin && (React.createElement(OrderValueMin, null,
                t('cho đơn hàng từ'),
                React.createElement(Currency, { value: condition.orderValueMin }))),
            condition.orderValueMax && (React.createElement(OrderValueMax, null,
                t('đến'),
                React.createElement(Currency, { value: condition.orderValueMax })))))));
};

const Coupon$2 = styled.div `
  text-transform: uppercase;
  padding: 0 6px;
  margin: 0 4px;
  background-color: #ef2741;
  color: #fff;
  border-radius: 2px;
  display: inline-block;
`;
const StyledIcon$1 = styled(SvgIcon)(({ theme }) => `
  margin-left: 5px;
  --button-icon-color: ${theme.brand.primary};
  `);
const DiscountPromotion = ({ promotion, }) => {
    var _a;
    if (!promotion || !((_a = promotion.benefit.money) === null || _a === void 0 ? void 0 : _a.length))
        return null;
    return (React.createElement(Flex, { marginTop: 2 },
        React.createElement(Box, { width: "8%" },
            React.createElement(StyledIcon$1, { name: "promotion", size: 20 })),
        React.createElement(Box, { width: "92%" },
            promotion.type === PromotionType.COUPON && (React.createElement(React.Fragment, null,
                t('Đã áp dụng mã giảm giá'),
                ' ',
                React.createElement(Coupon$2, null,
                    " ",
                    get(promotion, 'condition.coupon'),
                    " "),
                " ",
                t('giảm'),
                React.createElement(PromotionInfo, { money: get(promotion, 'benefit.money.0'), condition: promotion.condition }))),
            promotion.type === PromotionType.PRODUCT && (React.createElement(React.Fragment, null,
                t('Giảm trực tiếp'),
                ' ',
                React.createElement(PromotionInfo, { money: get(promotion, 'benefit.money.0'), condition: promotion.condition }))))));
};

const StyledIcon = styled(SvgIcon)(({ theme }) => `
  margin-left: 5px;
  --button-icon-color: ${theme.brand.primary};
  `);
const StyledCurrency = styled(Currency) `
  margin: 0 4px;
  color: #ed2101;
  font-weight: 500;
`;
const StyledVoucherName = styled.span `
  color: #ed2101;
  font-weight: 500;
`;
const DefaultPromotions = ({ defaultGifts, defaultPromotions, discount, defaultVouchers = [], }) => {
    return (React.createElement(React.Fragment, null,
        discount > 0 && (React.createElement(Flex, { marginTop: 2 },
            React.createElement(Box, { width: "8%" },
                React.createElement(StyledIcon, { name: "promotion", size: 20 })),
            React.createElement(Box, { width: "92%" },
                t('Giảm trực tiếp'),
                React.createElement(StyledCurrency, { value: discount })))),
        !!defaultGifts.length && React.createElement(DetailGifts, { gifts: defaultGifts }),
        defaultPromotions.map((promo, index) => (React.createElement(DiscountPromotion, { key: index, promotion: promo }))),
        defaultVouchers.map((voucher, index) => (React.createElement(Flex, { key: index, marginTop: 2 },
            React.createElement(Box, { width: "8%" },
                React.createElement(StyledIcon, { name: "promotion", size: 20 })),
            React.createElement(Box, { width: "92%" },
                t('Tặng'),
                React.createElement(Quantity$2, null,
                    "x",
                    voucher.quantity),
                ' ',
                React.createElement(StyledVoucherName, null, voucher.name)))))));
};

const Content$2 = styled.div(({ maxHeight, expanded }) => `
  background-color: #fff;
  max-height: ${maxHeight};
  width: 100%;
  overflow: hidden;
  border-radius: 8px;
  position: relative;
  ${expanded
    ? ''
    : `
  &:after {
    content: ' ';
    background: linear-gradient(transparent, hsla(0, 0%, 100%, 0) 70%, #fff 90%);
    background-image: linear-gradient(rgba(255, 255, 255, 0), rgb(255, 255, 255));
    position: absolute;
    bottom: 0;
    height: 40px;
    width: 100%;
  }
  `}
`);
const Wrappper = styled.div `
  position: relative;
`;
const StyledButtonChevron$1 = styled(ButtonChevron)(({ theme }) => `
  border-radius: 0;
  justify-content: center;
  padding: 24px 0;
  color: ${theme.brand.primary};
  width: calc(100% - 32px);
  margin-left: 16px;
  &:hover {
    color: ${theme.brand.primary}
  }
  span {
    margin-left: 4px;
  }
`);
const HEADER_HEIGHT = 72;
const HEADING_HEIGHT = 56;
const ProductShortDescription = ({ children, maxHeight, expandLabel, collapseLabel, moveTop = true, className, detailArticleScrollHeight, }) => {
    const [showMoreNeeded, setShowMoreNeeded] = useState(false);
    const [expanded, setExpanded] = useState(false);
    const descriptionRef = useRef(null);
    const descriptionCallbackRef = (node) => {
        if (node && !showMoreNeeded) {
            descriptionRef.current = node;
            setShowMoreNeeded(node.clientHeight < detailArticleScrollHeight);
        }
    };
    const handleClick = () => {
        setExpanded((prev) => {
            if (prev && moveTop && descriptionRef && descriptionRef.current) {
                const element = descriptionRef.current;
                window.scrollTo({
                    left: 0,
                    top: getElementOffset(element).top - HEADER_HEIGHT - HEADING_HEIGHT,
                });
            }
            return !prev;
        });
    };
    expandLabel = expandLabel || t('Xem thêm');
    collapseLabel = collapseLabel || t('Thu gọn');
    return (React.createElement(Wrappper, { className: className },
        React.createElement(Content$2, { ref: descriptionCallbackRef, maxHeight: expanded ? 'fit-content' : `${maxHeight}px`, expanded: expanded }, children),
        showMoreNeeded && (React.createElement(StyledButtonChevron$1, { block: true, link: true, direction: expanded ? 'up' : 'down', onClick: handleClick, "data-track-content": true, "data-content-region-name": "descriptionDetail", "data-content-name": "viewMore" }, expanded ? collapseLabel : expandLabel))));
};

const Wrapper$2 = styled.div `
  background-color: #fff;
  position: relative;
  border-radius: 8px;
`;
const Content$1 = styled.div(({ maxHeight, showMoreNeeded }) => `
  padding: 0 16px;
  background-color: #fff;
  max-height: ${maxHeight};
  width: 100%;
  overflow: hidden;
  border-radius: 8px;
  position: relative;
  ${showMoreNeeded &&
    `
  &:after {
    content: ' ';
    background: linear-gradient(transparent, hsla(0, 0%, 100%, 0) 70%, #fff 90%);
    background-image: linear-gradient(rgba(255, 255, 255, 0), rgb(255, 255, 255));
    position: absolute;
    bottom: 0;
    height: 40px;
    width: 100%;
  }
  `}
`);
const StyledModalBody = styled(ModalBody) `
  max-height: 85vh;
  overflow-y: scroll;
  ::-webkit-scrollbar {
    width: 10px;
  }

  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background: #cccccc;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #c8c5c5;
  }
`;
const ModalContent = styled.div `
  padding: 0 16px;
  background-color: #fff;
  width: 100%;
  border-radius: 8px;
  position: relative;
`;
const StyledButtonChevron = styled(ButtonChevron)(({ theme }) => `
  border-radius: 0;
  justify-content: center;
  color: ${theme.brand.primary};
  width: calc(100% - 32px);
  margin-left: 16px;
  padding: 24px 0;
  &:hover {
    color: ${theme.brand.primary}
  }
  span {
    margin-left: 4px;
  }
`);
const StyledModalHeader = styled(ModalHeader) `
  text-align: center;
`;
const ProductSpecifications = ({ attributeGroups, maxHeight, expandLabel = t('Xem thêm'), className, title = t('Thông số kỹ thuật'), }) => {
    const [showMoreNeeded, setShowMoreNeeded] = useState(false);
    const [expanded, setExpanded] = useState(false);
    const descriptionRef = useRef(null);
    useEffect(() => {
        if (descriptionRef && descriptionRef.current) {
            const element = descriptionRef.current;
            setShowMoreNeeded(element.clientHeight < element.scrollHeight);
        }
    }, [descriptionRef]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Wrapper$2, { className: className },
            React.createElement(BlockHeader, { title: title }),
            React.createElement(Content$1, { ref: descriptionRef, maxHeight: `${maxHeight}px`, showMoreNeeded: showMoreNeeded },
                React.createElement(Specifications, { attributeGroups: attributeGroups })),
            showMoreNeeded && (React.createElement(StyledButtonChevron, { block: true, link: true, direction: 'down', onClick: () => setExpanded(true), "data-track-content": true, "data-content-region-name": "specificationDetail", "data-content-name": "viewMore" }, expandLabel))),
        React.createElement(Modal, { show: expanded, onHide: () => setExpanded(false) },
            React.createElement(StyledModalHeader, null, title),
            React.createElement(StyledModalBody, null,
                React.createElement(ModalContent, null,
                    React.createElement(Specifications, { attributeGroups: attributeGroups }))))));
};

const Wrapper$1 = styled.div `
  border-radius: 8px;
  border: solid 1px #e0e0e0;
  padding: 16px;
`;
const Images = styled.div `
  display: flex;
  justify-content: space-around;
  align-items: center;
`;
const Image = styled.div `
  width: 60px;
  height: 60px;
`;
const Overlay = styled(Image) `
  border-radius: 4px;
  color: #b4b4b4;
  background-color: #f6f6f6;

  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const Text = styled.div `
  font-size: 0.625rem;
`;
const Retangle = styled.div `
  margin: 16px auto;
  position: relative;
  display: block;
  text-align: center;

  &::before {
    content: '';
    top: 10px;
    left: 0;
    width: 100%;
    height: 1px;

    border-radius: 2px;
    background-color: #d6dde4;
    display: inline-block;
    position: absolute;
  }

  span {
    color: #848788;
    background-color: #fff;
    padding: 0 10px;
    font-size: 10px;
    line-height: 1.6;
    text-transform: uppercase;

    position: relative;
    display: inline-block;
    border: solid 1px #e0e0e0;
  }
`;
const PriceInfo = styled.div `
  margin-bottom: 4px;
  display: flex;
  flex-direction: column;
`;
const PriceWrapper$3 = styled.div `
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;
const SavePrice = styled.span `
  margin-left: 4px;
  span {
    color: #eb2101;
    font-weight: bold;
  }
`;
const Footer = styled.div `
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const ViewDetail = styled.a `
  color: #047fff;
  cursor: pointer;
  text-decoration: none;
`;
const IconWrapper = styled.div `
  width: 16px;
  height: 16px;
`;
const StyledConcurrency = styled(Currency) `
  margin-left: 4px;
`;
const ImageWrapper = styled.div `
  display: flex;
  justify-content: space-around;
  align-items: center;
`;
const StyledProductPrice = styled(ProductPrice) `
  margin-left: 4px;
`;
const ProductCombo = (_a) => {
    var { productCombo, className, linkDetail = '', linkBuy = '' } = _a, props = __rest(_a, ["productCombo", "className", "linkDetail", "linkBuy"]);
    return (React.createElement(Wrapper$1, Object.assign({ className: className }, props),
        React.createElement(Images, null, productCombo.images
            .slice(0, 3)
            .map((image, index) => {
            if (productCombo.bundleProduct &&
                productCombo.bundleProduct.length > 3) {
                if (index == 2) {
                    return (React.createElement(Overlay, { key: index },
                        React.createElement("div", null,
                            productCombo.bundleProduct.length - 2,
                            " "),
                        React.createElement(Text, null, t('sản phẩm'))));
                }
            }
            return (React.createElement(ImageWrapper, { key: index },
                React.createElement(Image, null,
                    React.createElement(LazyImage, { contain: true, src: image.src, width: 60, height: 60 })),
                index !== productCombo.images.length - 1 && (React.createElement(SvgIcon, { name: "plus-default", size: 16, color: "#848788" }))));
        })),
        React.createElement(Retangle, null,
            React.createElement("span", null, t('Chỉ còn'))),
        React.createElement(PriceInfo, null,
            productCombo.price.price && (React.createElement(PriceWrapper$3, null,
                React.createElement(IconWrapper, null,
                    React.createElement(SvgIcon, { name: "cash-outline", size: 16, color: "green" })),
                React.createElement(StyledProductPrice, { price: productCombo.price.price, listedPrice: productCombo.price.listedPrice, horizontal: true }))),
            productCombo.price.listedPrice && (React.createElement(PriceWrapper$3, null,
                React.createElement(IconWrapper, null,
                    React.createElement(SvgIcon, { name: "promotion-fill", size: 16, color: "red" })),
                React.createElement(SavePrice, null,
                    t('Tiết kiệm:'),
                    React.createElement(StyledConcurrency, { value: productCombo.price.listedPrice - productCombo.price.price }))))),
        React.createElement(Footer, null,
            React.createElement(ViewDetail, { href: linkDetail }, t('Xem chi tiết')),
            React.createElement(Button, { variant: "primary", outline: true, link: true, href: linkBuy }, "Mua ngay"))));
};

const StyledSwiper = styled(Swiper) `
  .swiper-wrapper {
  }
`;
const ProductCombos = ({ products, name, className, }) => {
    return (React.createElement(Card, { header: React.createElement(BlockHeader, { title: t('Tiết kiệm hơn khi mua cùng {{name}}', { name: name }) }), className: className },
        React.createElement(StyledSwiper, { observer: true, observeParents: true, hasNavigation: true, slidesPerView: 4, slidesPerGroup: 4, spaceBetween: 16 }, products.map((product) => {
            return (React.createElement(ProductCombo, { productCombo: product, key: product.sku, linkDetail: product.linkDetail, linkBuy: product.linkBuy }));
        }))));
};

const Quantity$1 = styled.span `
  font-size: 0.75rem;
  color: #848788;
  margin-right: 4px;
`;
const Content = styled.div `
  display: flex;
  justify-content: space-around;
`;
const Benefit$1 = styled.div `
  flex: 1;
  display: flex;
  flex-direction: column;
`;
const Expired = styled.div `
  font-size: 0.75rem;
  color: #f78212;
  margin-left: 8px;
  display: flex;
  align-items: flex-end;
  margin-bottom: 6px;
`;
const Label$1 = styled.div `
  font-size: 0.75rem;
  color: #333333;
  flex: 1;
`;
const Coupon$1 = styled.div `
  text-transform: uppercase;
  padding: 0 6px;
  margin: 0 4px;
  background-color: #ef2741;
  color: #fff;
  border-radius: 2px;
  display: inline-block;
`;
const GiftImage$1 = styled.div `
  width: 10%;
  margin-right: 12px;
`;
const Discount$1 = styled(Currency) `
  color: #ed2101;
  margin-left: 4px;
`;
const StyledPrice = styled(Discount$1) `
  font-weight: bold;
`;
const PriceWrapper$2 = styled.div `
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;
const GiftWrapper$1 = styled(PriceWrapper$2) `
  margin-top: 8px;
`;
const PromotionIcon$1 = styled.div `
  width: 10%;
  height: 34px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  border: 1px solid #e0e0e0;
  margin-right: 12px;
`;
const Price$1 = styled.strong `
  color: #ed2101;
`;
const Promotion = ({ promotion, className, active = false, onClick, }) => {
    return (React.createElement(SelectOption, { isActive: active, activeBackground: "rgba(20, 53, 195, 0.08)", onClickOption: () => onClick(promotion.id), className: className },
        React.createElement(Content, null,
            React.createElement(Benefit$1, null,
                promotion.price && (React.createElement(PriceWrapper$2, null,
                    React.createElement(Price$1, null, t('Giá:')),
                    " ",
                    React.createElement(StyledPrice, { value: promotion.price }))),
                promotion.type === PromotionType.PRODUCT ? (React.createElement(React.Fragment, null,
                    promotion.benefit.money &&
                        !!promotion.benefit.money &&
                        promotion.benefit.money.map((moneyPromotion) => (React.createElement(Label$1, { key: moneyPromotion.id },
                            t('Đã giảm thêm'),
                            React.createElement(Discount$1, { value: moneyPromotion.money || 0 })))),
                    promotion.benefit.items &&
                        !!promotion.benefit.items &&
                        promotion.benefit.items.map((gift) => {
                            return (React.createElement(GiftWrapper$1, { key: gift.name },
                                React.createElement(GiftImage$1, null,
                                    React.createElement(LazyImage, { borderRadius: 2, contain: true, src: get(gift, 'image.src') || '' })),
                                React.createElement(Quantity$1, null,
                                    "x",
                                    gift.quantity),
                                React.createElement(Label$1, null, gift.name)));
                        }))) : (React.createElement(GiftWrapper$1, null,
                    React.createElement(PromotionIcon$1, null,
                        React.createElement(SvgIcon, { name: "promotion", size: 16, color: "#1435c3" })),
                    React.createElement(Label$1, null,
                        t('Đã áp dụng mã giảm giá'),
                        React.createElement(Coupon$1, null,
                            " ",
                            get(promotion, 'condition.coupon'),
                            " "),
                        t('giảm'),
                        React.createElement(PromotionInfo, { money: get(promotion, 'benefit.money.0'), condition: promotion.condition }))))),
            promotion.remainingTime && (React.createElement(Expired, null,
                t('Chỉ còn'),
                " ",
                promotion.remainingTime)))));
};

const ButtonWrapper = styled.div `
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
`;
const BuyNowButton = styled(Button) `
  height: 46px;
  width: 49%;
`;
const AddToCartButton = styled(BuyNowButton) `
  height: 46px;
`;
const ContactBtn = styled(Button) `
  height: 46px;
  width: 100%;
  &:hover {
    color: #333333;
  }
`;
const OutOfStockButton = styled(Button) `
  height: 46px;
  width: 100%;
`;
const ActionButtons = ({ onBuy, onAddToCart, contact, showContact = false, sku, }) => (React.createElement(ButtonWrapper, null,
    !showContact && (React.createElement(React.Fragment, null,
        React.createElement(BuyNowButton, { variant: "primary", block: true, flexDirection: "column", marginBottom: 2, onClick: onBuy, "data-track-content": true, "data-content-name": "buyNow", "data-content-target": "cart", "data-content-payload": JSON.stringify({
                sku,
            }) },
            React.createElement("strong", null, t('Mua ngay').toUpperCase())),
        React.createElement(AddToCartButton, { block: true, outline: true, variant: "primary", flexDirection: "column", onClick: onAddToCart, "data-track-content": true, "data-content-name": "addToCart", "data-content-target": "productDetail", "data-content-payload": JSON.stringify({
                sku,
            }) },
            React.createElement("strong", null, t('THÊM VÀO GIỎ HÀNG'))))),
    showContact && !!contact && (React.createElement("div", { "data-track-content": true, "data-content-region-name": "descriptionDetail", "data-content-name": "contactSale", "data-content-target": "productDetail", "data-content-payload": JSON.stringify({
            sku,
            screenName: 'productDetail',
        }), style: { width: '100%' } },
        React.createElement(ContactBtn, { block: true, variant: "primary", tag: "a", href: contact, marginBottom: 2, target: "_blank" },
            React.createElement("strong", null, t('LIÊN HỆ'))))),
    showContact && !contact && (React.createElement(OutOfStockButton, { block: true, outline: true, disabled: true, marginBottom: 2, variant: "disabled" },
        React.createElement("strong", null, t('HẾT HÀNG'))))));

const Container = styled.div `
  display: flex;
  flex-wrap: wrap;
`;
const Wrapper = styled.div(({ isSelected, isPackage }) => `
  display: flex;
  cursor: pointer;
  margin: 0.25rem 0.5rem 0.25rem 0;
  flex-direction: column;
  position: relative;
  ${isSelected ? `border: 1px solid ${theme.brand.primary};` : ''}
  ${isPackage
    ? `
  min-width: 30%;
  border: 1px solid #e4e5f0;
  height: 76px;
  background: #fbfbfd;
  box-sizing: border-box;
  border-radius: 0.5rem;
  margin-right: 0.5rem;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 0 0.5rem;
  `
    : ''} 
  `);
const PriceTag = styled.span(({ isSelected }) => `
position: absolute;
top: 0;
width: fit-content;
background: #bcbfd6;
border-radius: 0px 0px 4px 4px;
color: #fff;
font-weight: 500;
font-size: 12px;
line-height: 16px;
padding: 2px 8px;
${isSelected && `background: ${theme.brand.primary};`}
`);
const PriceWrapper$1 = styled.div(({ hasTag }) => `
    ${hasTag && `margin-top: 18px;`}
`);
const Price = styled.div(({ isSelected, isPackage }) => `
    color: ${isSelected ? `${theme.colors.blue600};` : ' #82869E;'}
    font-weight: bold;
    font-size: ${isPackage ? '20px' : '24px'};
    line-height: 28px;
`);
const ListedPrice = styled.div `
  font-size: 13px;
  line-height: 18px;
`;
const SupplierSalePrice = styled(Currency) `
  color: #82869e;
  text-decoration: line-through;
`;
const PricePackage = ({ prices, selectedPrice, setSelectedPrice, selectionPromotions, }) => {
    return (React.createElement(Container, null, prices.map((price, index) => (React.createElement(Wrapper, { isPackage: prices.length > 1 || (selectionPromotions === null || selectionPromotions === void 0 ? void 0 : selectionPromotions.length) > 1, isSelected: prices.length > 1 && selectedPrice === price.sellPrice, key: index, onClick: () => setSelectedPrice(price.sellPrice === null ? null : Number(price.sellPrice)) },
        price.tag && (React.createElement(PriceTag, { isSelected: selectedPrice === price.sellPrice }, price.tag)),
        React.createElement(PriceWrapper$1, { hasTag: !!price.tag },
            React.createElement(Price, { isSelected: selectedPrice === price.sellPrice, isPackage: prices.length > 1 || (selectionPromotions === null || selectionPromotions === void 0 ? void 0 : selectionPromotions.length) > 1 },
                React.createElement(Currency, { value: price.sellPrice || 0 })),
            price.supplierSalePrice &&
                price.supplierSalePrice !== price.sellPrice && (React.createElement(ListedPrice, null,
                React.createElement(SupplierSalePrice, { value: price.supplierSalePrice })))))))));
};

const Quantity = styled.span `
  font-size: 0.75rem;
  color: #848788;
  margin-right: 4px;
`;
const Benefit = styled.div `
  flex: 1;
  display: flex;
  flex-direction: column;
`;
const Label = styled.div `
  font-size: 0.75rem;
  flex: 1;
`;
const Coupon = styled.div `
  text-transform: uppercase;
  padding: 0 6px;
  margin: 0 4px;
  background-color: #ef2741;
  color: #fff;
  border-radius: 2px;
  display: inline-block;
`;
const GiftImage = styled.div `
  width: 32px;
  height: 32px;
  margin-right: 12px;
`;
const Discount = styled(Currency) `
  margin-left: 4px;
  font-weight: bold;
`;
const PriceWrapper = styled.div `
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;
const GiftWrapper = styled(PriceWrapper) `
  margin-top: 8px;
`;
const PromotionIcon = styled.div `
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  border: 1px solid #e0e0e0;
  margin-right: 12px;
`;
const Applied = styled.div `
  background: #30cd60;
  border-radius: 4px;
  padding: 2px 4px;
  color: #ffffff;
  font-weight: 500;
  font-size: 10px;
  line-height: 12px;
  text-transform: uppercase;
  display: inline-block;
`;
const PromotionDetail = ({ promotion, className, }) => {
    return (React.createElement(Benefit, { className: className }, promotion.type === PromotionType.PRODUCT ? (React.createElement(React.Fragment, null,
        promotion.benefit.money &&
            !!promotion.benefit.money &&
            promotion.benefit.money.map((moneyPromotion) => (React.createElement(Label, { key: moneyPromotion.id },
                t('Giảm trực tiếp'),
                ' ',
                React.createElement(Discount, { value: moneyPromotion.money || 0 }),
                ' ',
                React.createElement(Applied, null, t('Đã áp dụng'))))),
        promotion.benefit.items &&
            !!promotion.benefit.items &&
            promotion.benefit.items.map((gift) => {
                return (React.createElement(GiftWrapper, { key: gift.name },
                    React.createElement(GiftImage, null,
                        React.createElement(LazyImage, { borderRadius: 4, contain: true, src: get(gift, 'image.src') || '' })),
                    React.createElement(Quantity, null,
                        "x",
                        gift.quantity),
                    React.createElement(Label, null, gift.name)));
            }))) : (React.createElement(GiftWrapper, null,
        React.createElement(PromotionIcon, null,
            React.createElement(SvgIcon, { name: "promotion", size: 16, color: "#1435c3" })),
        React.createElement(Label, null,
            t('Đã áp dụng mã giảm giá'),
            ' ',
            React.createElement(Coupon, null,
                " ",
                get(promotion, 'condition.coupon'),
                " "),
            " ",
            t('giảm'),
            React.createElement(PromotionInfo, { money: get(promotion, 'benefit.money.0'), condition: promotion.condition }))))));
};

export { ActionButtons as A, DetailGifts as D, ProductImages as P, Quantity$2 as Q, ProductVariants as a, ProductVariant as b, DiscountPromotion as c, DefaultPromotions as d, ProductShortDescription as e, ProductSpecifications as f, ProductCombos as g, Promotion as h, PromotionInfo as i, PricePackage as j, PromotionDetail as k };
